import { useTranslation } from 'react-i18next';
import { Clamp } from '../../helpers';
import { InvoiceDownload } from '../../components';
import { IInvoice } from '../../interfaces';

type Props = {
    invoice: IInvoice;
};

const CheckoutNotAvailable = ({ invoice }: Props) => {
    const { t } = useTranslation();

    return (
        <Clamp>
            <p>{t('checkoutNotAvailable')}</p>
            <InvoiceDownload invoice={invoice} />
        </Clamp>
    );
};

export default CheckoutNotAvailable;
